/* eslint-disable no-console */
<template>
  <div>
    <div class="header_unit header_bg_white">
      <div class="header_box">
        <div class="menu_left">
          <router-link :to="{ name: 'top' ,
                    params: { brandPath: $route.params.brandPath}} "><p class="top_tit">＜戻る</p></router-link>
        </div>
        <div class="menu_center">
          <p class="menu_center_tex_s"> </p>
          <p class="menu_center_tex_l">熱中症アラート</p>
        </div>
      </div>
    </div>
    <HeatStrokeIndexMap />
  </div>
</template>

<script>
import HeatStrokeIndexMap from '@/app/components/HeatStrokeIndexMap.vue'
export default {
  name: 'manageHeatStrokeIndexMap',
  components: {
    HeatStrokeIndexMap
  }
}
</script>